module.exports = __webpack_public_path__ + "static/media/tdc_logo.5d4956e0.png";